<template>
    <div>
        <div class="search-box">
            <p>系别：</p>
            <a-select 
                class="input-box" 
                allowClear 
                show-search 
                :filter-option="filterOption"
                 v-model="searchFrom.departmentCode">
                <a-select-option v-for="(item,index) in xbArr" :key="index" :value="item.dataCode">{{item.dataName}}</a-select-option>
            </a-select>
            <p>学年：</p>
            <a-date-picker
                class="input-box"
                mode="year"
                format='YYYY'
                v-model="year" 
                :open='yearShowOne' 
                @openChange="openChangeOne"
                @panelChange="panelChangeOne">
                <a-input  v-model="searchFrom.schoolYear" />
            </a-date-picker>
            <p>教师名：</p>
            <a-input class="input-box" v-model="searchFrom.teacherName" />
            <a-button type="primary" icon="search" @click="searchList">搜索</a-button>
            
        </div>
        <div class="operation-box">
            <a-button type="primary" v-if="permissions.indexOf('undergraduate:culture:invigilator:add')>-1" icon="plus" class="btn" @click="$refs.info.showDrawer('新增','')">新增</a-button>
            <a-popconfirm placement="top" title="确定删除？" ok-text="确定" cancel-text="取消" @confirm="selectedRowKeys[0] == null ? selectedCheck() : remove(selectedRowKeys[0])">
                <a-button 
                    type="primary"
                    icon="minus" 
                    class="btn" 
                    v-if="permissions.indexOf('undergraduate:culture:invigilator:delete')>-1">
                    删除
                </a-button>
            </a-popconfirm>
            <a-button 
                type="primary"
                icon="edit"
                class="btn" 
                @click="selectedRowKeys[0] == null ? selectedCheck() : $refs.info.showDrawer('编辑',selectedRowKeys[0])"
                v-if="permissions.indexOf('undergraduate:culture:invigilator:edit')>-1">
                 修改
            </a-button>
            <a-button type="primary" class="btn" icon="file-search" v-if="permissions.indexOf('undergraduate:culture:invigilator:query')>-1" @click="selectedRowKeys[0] == null ? selectedCheck() : $refs.info.showDrawer('查看',selectedRowKeys[0])" >查看详情</a-button>
            <a-upload
                    name="file"
                    :multiple="false"
                    :action="$store.state.axiosUrl+'/api-ir/bachelor/invigilate/import'"
                    :headers="headers"
                    @change="handleChange"
                    :showUploadList="false"
                >
                    <a-button type="primary" v-if="permissions.indexOf('undergraduate:culture:wholeMentor:import')>-1" class="btn"> <a-icon type="upload" /> 批量导入</a-button>
                </a-upload>
        </div>
        <a-table 
            rowKey='id'
            :customRow="onClickRow"
            :columns="columns" 
            :data-source="data"
            :loading="loading"
            :pagination="pagination"
            @change="handleTableChange"
            :scroll="{ x: '100%' }"
            :row-selection="{ type:'radio',selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
            bordered>
            <!-- <template slot="id" slot-scope="text">
                <a class="action-btn" @click="$refs.info.showDrawer('查看',text)">详情</a>
                <a-divider type="vertical" />
                <a class="action-btn" @click="$refs.info.showDrawer('编辑',text)">编辑</a>
                <a-divider type="vertical" />
                <a-popconfirm
                    title="确定删除？"
                    ok-text="确定"
                    cancel-text="取消"
                    @confirm="remove(text)"
                >
                    <a class="action-btn">删除</a>
                </a-popconfirm>
            </template> -->
        </a-table>
        <info ref="info"></info>
    </div>
</template>
<script>
    import { getDicts } from '@/baseAPI/dictionary'
    import { list,del } from '@/baseAPI/undergraduate/culture/invigilator'
    import Info from './modules/invigilatorInfo'
    import { getSchoolYear,selectedCheck } from '@/baseAPI/util'
    export default {
        name: 'teacher',
        components: {
            Info
        },
        computed:{
            
        },
        data () {
            return {
                headers:{
                    'Authorization':'Bearer '+ this.$store.state.access_token
                },
                selectedRowKeys: [],
                permissions:[],
                columns:[],
                data:[],
                loading: false,
                pagination:{
                    pageSize: 10,
                    current: 0,
                    total:0,
                },
                searchFrom:{
                    size: '',
                    current: '',
                    teacherName:'',
                    departmentCode:'',
                    schoolYear:'',
                },
                xbArr:[],
                xnArr:[],
                year:'',
                yearShowOne:false,
            }
        },
        mounted () {
            this.permissions=this.$store.state.user.permissions==null?[]:this.$store.state.user.permissions;
            getDicts({dataCode:'XY',status:true}).then(res=>{
                this.xbArr=res.data.dicts;
            })
            getDicts({dataCode:'XN',status:true}).then(res=>{
                this.xnArr=res.data.dicts;
            })
            this.searchFrom.schoolYear=getSchoolYear()+'-'+(getSchoolYear()+1)
            this.year=getSchoolYear()+''
            
            this.fetch()
        },
        methods:{
            hideWinterExamCount() {
                if (this.searchFrom.schoolYear) {
                    return this.searchFrom.schoolYear.split('-')[0] >= 2025;
                }
                return false;
            },
            generateColumns() {
                const baseColumns = [
                    {
                        title: '序号',
                        dataIndex: 'id',
                        align:'center',
                        width:70,
                        customRender: (text, row, index) => {
                            return { children: index+1};
                        },
                    },
                    {
                        title: '系别',
                        dataIndex: 'orgName',
                        align:'center',
                    },
                    {
                        title: '教师名',
                        dataIndex: 'teacherName',
                        align:'center'
                    },
                    {
                        title: '秋季监考次数',
                        dataIndex: 'autumnCount',
                        align:'center'
                    },
                    {
                        title: '春季监考次数',
                        dataIndex: 'springCount',
                        align:'center'
                    },
                    {
                        title: '合计',
                        dataIndex: 'totalCount',
                        align:'center',
                    },
                    {
                        title: '学年',
                        dataIndex: 'schoolYear',
                        align:'center',
                    }
                ];
                
                if (!this.hideWinterExamCount()) {
                    baseColumns.splice(4, 0, {
                        title: '冬季监考次数',
                        dataIndex: 'winterCount',
                        align:'center'
                    });
                }
                
                return baseColumns;
            },
            handleChange(info) {
                if(typeof info.file.response != 'undefined'){
                    var res=info.file.response;
                    if(res.success){
                        this.$notification['success']({
                            message: '成功',
                            description:'批量导入成功'
                        });
                    }else{
                        this.$notification['error']({
                            message: '批量导入失败',
                            description:res.errorMessage,
                        });
                    }
                }
            },
            selectedCheck(){
                selectedCheck()
            },
            onSelectChange(selectedRowKeys) {
                this.selectedRowKeys = selectedRowKeys;
            },
            onClickRow(record,index){
                return {
                    on: { // 事件
                        click: (event) => {
                            this.onSelectChange([record.id])
                        }
                    },

                }  
            },
            handleTableChange(pagination){
                this.selectedRowKeys=[];
                const pager = { ...this.pagination };
                pager.current = pagination.current;
                this.pagination = pager;
                this.fetch();
            },
            // 弹出日历和关闭日历的回调
            openChangeOne(status) {
                    if (status){
                        this.yearShowOne =  true
                    }
                },
            // 得到年份选择器的值
            panelChangeOne(value) {
                this.year=this.getTimeStr(value._d,'yyyy')
                this.searchFrom.schoolYear=this.year+'-'+(this.year-0+1);
                this.yearShowOne = false;
            },
            fetch() {
                this.columns = this.generateColumns();
                this.loading = true;
                this.searchFrom.size=this.pagination.pageSize;
                this.searchFrom.current=this.pagination.current;
                list(this.searchFrom).then(res=>{
                    this.pagination.total = res.data.total;
                    this.data = res.data.records;
                    this.loading = false;
                })
            },
            filterOption(input, option) {
                return (
                    option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
                );
            },
            searchList(){
                this.pagination.current=1;
                this.fetch()
            },
            remove(id){
                del(id).then(res=>{
                    if(res.data.success){
                        this.$notification['success']({
                            message: '成功',
                            description:'删除监考信息成功',
                        });
                        this.fetch()
                    }else{
                        this.$notification['error']({
                            message: '失败',
                            description:res.data.errorMessage,
                        });
                    }
                })
            },
        }
    }
</script>
<style scoped>
    .search-box
    {
        padding-bottom: 24px;
        border-bottom: 1px solid rgba(151,151,151,0.60);
        margin-bottom: 10px;
    }
    .search-box p
    {
        display: inline-block;
    }
    .search-box .right-btn
    {
        float: right;
        margin-left: 1rem;
    }
    .search-box .input-box{
        margin-right: 1rem;
        width: 13rem;
    }
    .ant-table-wrapper >>> .ant-table-thead > tr > th,
    .ant-table-wrapper >>> .ant-table-tbody > tr > td{
        padding: 14px;
    }
    .action-btn{
        color: #40a9ff;
        display: inline-block;
    }
    .ant-table-wrapper .show-input{
        height: 23px;
        line-height: 23px;
    }
    .ant-table-wrapper .show-input >>> .ant-select-selection{
        background-color: transparent;
        border: none;
        color: rgba(0, 0, 0, 0.65);
    }
    .ant-table-wrapper .show-input >>> .ant-select-arrow{
        display: none;
    }

    .operation-box{
        display: flex;
        margin-bottom: 10px;
    }

    .operation-box .btn{
        margin-right: 1rem;
    }

</style>
